/**
 * Featured Video: opens the block's link in Magnific Popup.
 * The URL comes from the block's href, so nothing is hardcoded here.
 * YouTube/Vimeo links open as iframes; uploaded MP4s open in a <video>.
 */
( ( $ ) => {
	const youtubeId = ( url ) => {
		const match = url.match( /(?:youtu\.be\/|[?&]v=|\/(?:embed|shorts|live)\/)([\w-]{11})/ );
		return match ? match[ 1 ] : '';
	};

	// Returns "123456?autoplay=1" or, for unlisted videos, "123456?autoplay=1&h=abc123".
	const vimeoId = ( url ) => {
		const match = url.match( /vimeo\.com\/(?:.*?\/)?(\d+)(?:\/([\da-f]{6,}))?/ );
		if ( ! match ) {
			return '';
		}
		let hash = match[ 2 ] || '';
		if ( ! hash ) {
			try {
				hash = new URL( url ).searchParams.get( 'h' ) || '';
			} catch ( e ) {}
		}
		return `${ match[ 1 ] }?autoplay=1${ hash ? `&h=${ hash }` : '' }`;
	};

	$( () => {
		const $links = $( '.mvcf-featured-video__play' );
		if ( ! $links.length || ! $.fn.magnificPopup ) {
			return;
		}

		$links.magnificPopup( {
			type: 'iframe',
			mainClass: 'mfp-fade mvcf-video-popup',
			removalDelay: 200,
			preloader: false,
			fixedContentPos: false,
			iframe: {
				patterns: {
					// "youtu" matches youtube.com, youtu.be and youtube-nocookie.com.
					youtube: {
						index: 'youtu',
						id: youtubeId,
						src: 'https://www.youtube-nocookie.com/embed/%id%?autoplay=1&rel=0',
					},
					vimeo: {
						index: 'vimeo.com/',
						id: vimeoId,
						src: 'https://player.vimeo.com/video/%id%',
					},
				},
			},
			callbacks: {
				// Uploaded MP4s: switch this item to inline and build the player.
				elementParse( item ) {
					if ( item.el.data( 'video-type' ) !== 'file' ) {
						return;
					}
					const $video = $( '<video>', {
						src: item.src,
						poster: item.el.data( 'video-poster' ) || '',
						controls: true,
						autoplay: true,
						playsinline: true,
						preload: 'auto',
						'aria-label': item.el.data( 'video-title' ) || 'Video',
					} );
					item.type = 'inline';
					item.src = $( '<div class="mvcf-video-file"></div>' ).append( $video );
				},
				open() {
					const title = this.currItem.el.data( 'video-title' ) || 'Video';
					this.content.find( 'iframe' ).attr( 'title', title );
				},
				// Detached <video> elements can keep playing audio, so stop it.
				beforeClose() {
					this.content.find( 'video' ).each( ( i, video ) => {
						video.pause();
						video.removeAttribute( 'src' );
						video.load();
					} );
				},
			},
		} );
	} );
} )( window.jQuery );
